<template>
  <f7-sheet class="high darker" :backdrop="true" :opened="show" @sheet:closed="$emit('closed')">
    <f7-toolbar>
      <div class="left">

      </div>
      <div class="right">
        <f7-link sheet-close>
          Sluiten
        </f7-link>
      </div>
    </f7-toolbar>

    <f7-block-header>
      {{ header_text }}
    </f7-block-header>
    <f7-list class="mt-4 mb-4 list-strong list-outline list-dividers">
      <f7-list-item title="Feedback" smart-select :smart-select-params="{openIn: 'popover', closeOnSelect: true}" @smartselect:closed="set_type($event)" ref="type_select">
        <select name="feedback" v-model="type">
          <option value="0" selected>Algemeen</option>
          <option value="1">Lawaai</option>
          <option value="2">Rommel</option>
          <option value="3">Intimidatie</option>
          <option value="4">Ongepast gedrag</option>
          <option value="5">Compliment</option>
          <option value="6">Lekker getraind</option>
          <option value="7">Verbeterpunt</option>
          <option value="8">Wens</option>
          <option value="9">Voor de app</option>
        </select>
      </f7-list-item>
    </f7-list>
    <f7-text-editor
        ref="text-editor"
        :value="feedback"
        @texteditor:change="feedback = $event"
        placeholder="Jouw feedback..."
        mode="popover"
        :buttons="['bold', 'italic', 'underline', 'strikeThrough']"
        style="--f7-text-editor-height: 150px"
    />
    <f7-block-footer style="text-align: right;">
      <strong>{{ feedback.length }}</strong>/4096
      <f7-button class="mt-3" fill large @click="send_feedback">
        Verzend
      </f7-button>
    </f7-block-footer>

  </f7-sheet>
</template>

<script>

export default {
  components: {},

  props: {
    'show': {default: false},
    'title': {default: 'Feedback'},
    'gym_id': {default: null},
    'training_slot_id': {default: null},

    'header_text': {default: 'Was het eiland niet netjes opgeruimd? Teveel lawaai van de buren? Of wil je een veer in de reet steken van een mede sporter? Dat kan! Laat hier je feedback achter en we pakken het (anoniem) op.'},
  },

  mixins: [
    //
  ],

  data: function () {
    return {
      feedback: '',
      type: 0,
    };
  },

  computed: {
    //
  },

  created() {
    //
  },

  mounted() {
    //
  },

  methods: {
    set_type(event) {
      this.$nextTick(() => {
        let smartSelect = this.$refs.type_select.f7SmartSelect;
        if(typeof smartSelect !== 'undefined') {
          this.type = smartSelect.getValue();
        }
      });
    },
    send_feedback() {
      this.$store.dispatch('feedback/store', {
        gym_id: this.gym_id,
        training_slot_id: this.training_slot_id,
        type: this.type,
        text: this.feedback,
      }).then(response => {
        this.$store.dispatch('notifications/addSuccessNotification', {
          message: 'Bedankt voor je feedback!'
        });
        this.$emit('closed');
      });
    },
  },

  watch: {
    //
  }
};
</script>
